export default __webpack_public_path__ + "img/6e8c0db788c0ed69172be1c6acbb210d.svg";